// 2022/01/23 15:00:00 GMT+0800 1642921200000
export const COUNTDOWN = '1644292800000'
// export const COUNTDOWN = new Date(new Date().getTime() + 10000)
//   .getTime()
//   .toString()
